<template>
    <div>
        <Modal v-model="show" :width="500" :footer-hide="true" title="会员充值">
            <div style="display:flex;">
                <div class="pay_div">
                    <div class="pay-username">
                        <div>账号:{{ userName }}</div>
                    </div>
                    <!-- 账户金额详情 -->
                    <div>
                        <div style="border: none;">
                            <div class="custome-info-wrap">
                                <!-- <p>{{ '账户余额:' + memberFund + '元' }}</p>
                                <p>冻结金额:<span style="color: green">{{depositBablance + '元' }}</span></p>
                                <p>订单总额:<span>{{orderTotalMoney+ '元' }}</span></p>
                                <p>建议充值金额:<span style="color: red">{{payMoney+ '元' }}</span></p> -->
                                <!-- <p>{{ '账户金额:' + memberFund + '元' }}</p>
                                <p>{{ '定金金额:' + memberDepositBablance + '元' }}</p>
                                <p>{{ '冻结金额:' + depositBablance + '元' }}</p>
                                <p>{{ '可用余额:' + (memberFund-depositBablance).toString() + '元' }}</p> -->

                                <Tooltip content="账户金额包含了冻结金额" placement="right">
                                    <p>{{
                                            '账户金额:' + getNumberThousandString(getNumberFloorDecimal(memberFund), '0.00') + '元'
                                        }}</p>
                                </Tooltip>
                                <br>
                                <Tooltip content="会员定金单的定金金额汇总" placement="right">
                                    <p>{{
                                            '定金金额:' + getNumberThousandString(memberDepositBablance, '0.00') + '元'
                                        }}</p>
                                </Tooltip>
                                <br>
                                <Tooltip max-width="200"
                                         content="冻结金额=订单全额-定金，会员已生成发货单，苗场未点发货的金额汇总（不含定金）"
                                         placement="right">
                                    <p>{{ '冻结金额:' + getNumberThousandString(depositBablance, '0.00') + '元' }}</p>
                                </Tooltip>

                                <p>{{
                                        '可用余额:' + getNumberThousandString(getNumberFloorDecimal(numberSubtraction(memberFund, depositBablance), 2), '0.00') + '元'
                                    }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="custome_value">
                        <span>充值金额:</span>
                        <Input v-model="orderAmount" placeholder="输入充值金额"
                               style="width:160px;margin-left: 10px;border:none;font-size: 22px;color: red;">
                        </Input>
                        <span style="font-size: 10px;color:red;">（* 最多保留小数点后两位数字）</span>
                    </div>
                    <div class="pay_type" v-if="isOpenPay">
                        <!-- <RadioGroup v-model="payType" class="pay_type_group pay-type-group">
                            <Radio name="some-radios" :value="WeiXin" :label= "WeiXin"
                                @change="hidePayResult" style="display: inline-block !important;"><img src="../../../assets/pay/pay_weixin.png" alt="微信支付">微信</Radio>
                            <Radio name="some-radios" :value="AliPay" :label= "AliPay"
                                @change="hidePayResult" style="display: inline-block !important;"><img src="../../../assets/pay/pay_zhifubao.png" alt="支付宝支付">支付宝</Radio>
                        </RadioGroup> -->

                        <RadioGroup v-model="payType" v-if="payCode == 'ABC'">
                            <Radio v-for="item in payWays" :key="item.val" :label="item.val" style="font-size:16px;">{{
                                    item.label
                                }}
                            </Radio>
                        </RadioGroup>

                        <div v-for="option in payTypeOptions" :key="option.value" style="margin-top: 20px;">
                            <input type="radio" :value="option.value" v-model="payCode">
                            <img :src="option.srcUrl"><label
                            style="margin-left: 20px;color: red;">{{ option.tips }}</label>
                        </div>

                        <!-- <div v-if="payCode == 'CMB'">
                            银联支付(微信、支付宝、银联)
                        </div> -->

                        <div class="pay_logo">
                            <Button
                                style="width:450px;margin-top:25px; background-color:#333 !important;height: 38px;line-height: 38px;padding: 0px;font-size: 16px;"
                                type="primary" variant="success" @click="submitPay()">
                                <span>立即充值</span>
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </Modal>
        <Modal v-model="showPayResult" :footer-hide="true" :width="600" title="会员充值">
            <div>
                <div class="pay_result">
                    <div style="font-size:24px;color:red;text-align:center;">请您及时充值，以便尽快到帐订购！</div>
                    <div style="display:flex;margin-top:10px;font-size:16px;justify-content: space-between;">
                        <div style="line-height: 30px;">
                            <div>账号:{{ userName }}</div>
                            <div>单号:{{ orderNo }}</div>
                            <div>金额:{{ orderAmount }}</div>
                            <div>状态:{{ payStatus }}</div>
                            <div>方式:{{ getPayType() }}</div>
                            <!--							<div> <a v-if="payLink" style="color:red;" v-clipboard:copy="payLink"-->
                            <!--									v-clipboard:success="onCopy" v-clipboard:error="onError">点击复制支付链接</a></div>-->

                        </div>
                        <div v-if="showQrCode" style="margin-left:10px; text-align:center;">
                            <div id="qrcodeImg"></div>
                            <div style="margin-top: 5px;">{{ getPayType() }}扫码支付</div>
                        </div>
                    </div>
                    <div v-if="showQueryButton" style="display: flex; margin-top:20px;justify-content: space-between;">
                        <div style="font-size:12px; color:red;">支付完成前请不要关闭此支付验证窗口<br/>支付完成后，请根据您支付的情况点击右边按钮。
                        </div>
                        <div>
                            <Button style="width:180px;" type="success" variant="warning" @click="queryPay()">
                                <span>我已支付</span>
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {WEIXIN, ALIPAY, payTypeFormat} from '@/libs/baseModelFormat';
import {
    getMemberDetailInfo,
    getPaymentChannel,
    createABCWeixin,
    createABCAliPay,
    createWeiXinPay,
    createAliPay,
    QueryABCPay,
    QueryCMBPay,
    QueryCCBCPay,
    queryWeiXinPay,
    queryAliPay,
    getPayPlatformConfigList,
    createCMBPay,
    createCCBCPay
} from '@/api/modules/sale-management/sale-approve';
import {getNumberThousandString, getNumberFloorDecimal, numberSubtraction} from '@/libs/tableRowTimeRender';
import QRCode from 'qrcodejs2';

export default {
    name: "PayModal",
    mounted() {
    },
    data() {
        return {
            userUuid: '',
            userName: '',
            userPersonName: '',
            show: false,
            orderAmount: 0,
            payType: WEIXIN,
            showSpin: false,
            showSpinQuery: false,
            orderNo: "",
            payStatus: "未支付",
            showPayResult: false,
            showQrCode: false,
            showQueryButton: true,
            payLink: '',
            paymentChannel: '1',
            memberFund: 0,
            memberDepositBablance: 0,
            depositBablance: 0,
            orderTotalMoney: 0,
            payMoney: 0,
            payWays: [],
            payTypeOptions: [],
            payCode: '',
            isOpenPay: false
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        getNumberThousandString,
        getNumberFloorDecimal,
        numberSubtraction,
        init() {
            this.payWays = [];
            this.payWays.push({val: WEIXIN, label: payTypeFormat(WEIXIN)});
            this.payWays.push({val: ALIPAY, label: payTypeFormat(ALIPAY)});
            this.getpayConfigList();
        },
        getMemberDetailInfo(userUuid) {
            let data = {
                userUuid: userUuid
            };
            getMemberDetailInfo(data).then(res => {
                if (res.code === 0) {
                    this.userUuid = res.data.memberLoginUuid;
                    this.userName = res.data.userName;
                    this.memberFund = res.data.memberFund ? res.data.memberFund : 0;
                    this.depositBablance = res.data.depositBablance ? res.data.depositBablance : 0;
                    this.memberDepositBablance = res.data.memberDepositBablance;
                    this.orderTotalMoney = res.data.orderTotalMoney;
                    this.payMoney = res.data.orderTotalMoney;
                    //this.setDefaultPayValue(res.data.orderTotalMoney);
                }
            });
        },
        getPaymentChannel() {
            getPaymentChannel().then(res => {
                if (res.code === 0) {
                    this.paymentChannel = res.data.paymentChannel;
                }
            });
        },
        // 复制成功时的回调函数
        onCopy(e) {
            this.$Message.success('内容已复制到剪切板！');
        },
        // 复制失败时的回调函数
        onError(e) {
            this.$Message.success('抱歉，复制失败！');
        },
        onClose(e) {
            if (this.showPayResult && this.payStatus === '未支付') {
                e.preventDefault();
                this.$Modal.confirm({
                    title: '提示',
                    content: '充值未完成支付，是否确认离开该页面？',
                    onOk: () => {
                        this.hidePayResult();
                        this.showPayResult = false;
                    },
                    onCancel: () => {
                    }
                });
            }
        },
        showModal(userUuid, amount = 0) {
            this.userUuid = userUuid;
            this.orderAmount = amount;
            this.getPaymentChannel();
            this.getMemberDetailInfo(userUuid);
            this.show = true;
        },
        hidePayResult(e) {
            this.showPayResult = false;
            this.showQrCode = false;
        },
        getPayType() {
            if (this.payCode === 'CMB') {
                return '支付宝、银联';
            } else if (this.payCode === 'CCBC') {
                return '微信、支付宝、建行APP、云闪付';
            } else if (this.payType === "WeiXin" || this.payCode === "WeiXin") {
                return '微信';
            } else if (this.payType === "AliPay" || this.payCode === "AliPay") {
                return '支付宝';
            } else if (this.payCode === 'ABC') {
                if (this.payType === 'Weixin') {
                    return '微信';
                } else if (this.payType === "Alipay") {
                    return '支付宝';
                }
            }

        },
        qrcode(url) {
            document.getElementById('qrcodeImg').innerHTML = '';
            new QRCode('qrcodeImg', {
                width: 180,
                height: 180,
                text: url, // 二维码地址
                colorDark: '#000',
                colorLight: '#fff'
            });
        },
        setDefaultPayValue(value) {
            this.orderAmount = value;
        },
        getpayConfigList() {
            getPayPlatformConfigList().then(res => {
                if (res.code == 0) {
                    let payConfigList = res.data.records.filter(x => x.isApp == 0 && x.platformConfigStatus == 1).sort((a, b) => (a.code === 'WeiXin' ? -1 : b.code === 'WeiXin' ? 1 : 0));
                    this.isOpenPay = payConfigList.length > 0 ? true : false;
                    if (this.isOpenPay) {
                        this.payCode = payConfigList[0].code;
                        this.payTypeOptions = payConfigList.filter(x => x.code != 'ABC').map(x => this.getPayOptins(x.code));
                    }

                }

            });
        },
        getPayOptins(code) {
            let srcUrl;
            let tips = '';
            if (code == 'CCBC') {
                srcUrl = require('../../../assets/icons/ccb_union_pay.png');
                tips = '(支付有效时间是15分钟)';
            } else if (code == 'CMB') {
                srcUrl = require('../../../assets/icons/cmb_union_pay-2.png');
                tips = '(支付有效时间是12小时)';
            } else if (code == 'WeiXin') {
                srcUrl = require('../../../assets/pay/pay_weixin.png');
                tips = '(支付有效时间是2小时)';
            }
            return {srcUrl, value: code, tips};
        },
        submitPay() {
            if (this.payCode == 'CMB') {
                this.submitPay_CMB();
            } else if (this.payCode == 'CCBC') {
                this.submitPay_CCBC();
            } else if (this.payCode == "WeiXin") {
                this.submitPay_self();
            } else if (this.payCode == 'ABC') {
                if (this.paymentChannel === "1") {
                    this.submitPay_nonghang();
                } else {
                    this.submitPay_self();
                }
            }

        },
        CheckAmount() {
            let exp = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
            if (!exp.test(this.orderAmount) || this.orderAmount <= 0) {
                this.$Modal.info({title: '提示', content: '填写的充值金额格式不对！'});
                return false;
            }
            if (this.orderAmount > 50000) {
                this.$Modal.info({title: '提示', content: '充值金额不能超过5万!'});
                return false;
            }
            return true;
        },
        submitPay_CMB() {
            if (!this.CheckAmount()) {
                return;
            }
            this.hidePayResult();
            this.showSpin = true;
            createCMBPay({
                orderAmount: this.orderAmount,
                userUuid: this.userUuid
            }).then(res => {
                this.showSpin = false;
                this.showPayResult = true;
                this.showQrCode = true;
                //this.showQueryButton=true;
                this.orderNo = res.data.orderNo;
                this.payLink = res.data.qrUrl;
                setTimeout(() => {
                    this.qrcode(res.data.qrUrl);
                    this.queryPay_CMB();
                }, 300);

            });
        },
        submitPay_CCBC() {
            if (!this.CheckAmount()) {
                return;
            }
            this.hidePayResult();
            this.showSpin = true;
            createCCBCPay({
                orderAmount: this.orderAmount,
                userUuid: this.userUuid
            }).then(res => {
                this.showSpin = false;
                this.showPayResult = true;
                this.showQrCode = true;
                this.showQueryButton = true;
                this.orderNo = res.data.orderNo;
                this.payLink = res.data.qrUrl;
                setTimeout(() => {
                    this.qrcode(res.data.qrUrl);
                }, 300);
            });
        },
        submitPay_nonghang() {
            let exp = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
            if (!exp.test(this.orderAmount) || this.orderAmount <= 0) {
                this.$Modal.info({title: '提示', content: '填写的充值金额格式不对！'});
                return;
            }
            this.hidePayResult();
            if (this.payType === 'Weixin') {
                this.showSpin = true;
                createABCWeixin({
                    orderAmount: this.orderAmount,
                    userUuid: this.userUuid
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    this.payLink = res.data.qrUrl;
                    setTimeout(() => {
                        this.qrcode(res.data.qrUrl);
                    }, 300);
                });
            } else if (this.payType === 'Alipay') {
                this.showSpin = true;
                createABCAliPay({
                    orderAmount: this.orderAmount,
                    userUuid: this.userUuid
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    this.payLink = '';
                    setTimeout(() => {
                        this.qrcode(res.data.qrUrl);
                    }, 300);
                });
            }
        },
        submitPay_self() {
            let exp = /^([1-9][\d]{0,7}|0)(\.[\d]{1,2})?$/;
            if (!exp.test(this.orderAmount) || this.orderAmount <= 0) {
                this.$Modal.info({title: '提示', content: '填写的充值金额格式不对！'});
                return;
            }
            this.hidePayResult();
            if (this.payType === 'Weixin' || this.payCode === 'WeiXin') {
                this.showSpin = true;
                createWeiXinPay({
                    orderAmount: this.orderAmount,
                    userUuid: this.userUuid
                }).then(res => {
                    console.log(res);
                    if (res.code !== 0) {
                        return;
                    }

                    this.showSpin = false;
                    this.showPayResult = true;
                    this.showQrCode = true;
                    this.orderNo = res.data.orderNo;
                    setTimeout(() => {
                        this.qrcode(res.data.payUrl);
                        this.queryPay_wx();
                    }, 300);
                });
            } else if (this.payType === 'Alipay' || this.payCode === 'Alipay') {
                this.showSpin = true;
                createAliPay({
                    orderAmount: this.orderAmount
                }).then(res => {
                    this.showSpin = false;
                    this.showPayResult = true;
                    this.orderNo = res.data.orderNo;
                    window.open(res.data.aliPayUrl, "_blank");
                });
            }
        },
        queryPay() {
            if (this.payCode == 'CMB') {
                this.queryPay_CMB();
            } else if (this.payCode == 'CCBC') {
                this.queryPay_CCBC();
            } else if (this.payCode == "WeiXin") {
                this.queryPay_self();
            } else if (this.payCode == 'ABC') {
                if (this.paymentChannel === "1") {
                    this.queryPay_nonghang();
                } else {
                    this.queryPay_self();
                }
            }
        },
        closePayWindow() {
            this.show = false;
            this.showPayResult = false;

            this.$emit('refresh-data');
        },
        queryPay_CMB() {
            this.showQueryButton = false;
            clearInterval(this.timer);   //清除定时器
            this.timer = setInterval(() => {
                if (!this.showPayResult) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                }
                QueryCMBPay({
                    orderNo: this.orderNo,
                    orderAmount: this.orderAmount
                }).then(res => {
                    if (res.data.code === 0) {
                        clearInterval(this.timer);   //清除定时器
                        this.timer = null;
                        this.timerCount = 0;
                        this.payStatus = '已支付';
                        this.showPayResult = false;
                        this.$Modal.info({title: '提示', content: '支付成功！'});


                    } else if (res.data.code != 4) {
                        this.$Modal.info({title: '提示', content: res.message});
                        clearInterval(this.timer);   //清除定时器
                        this.timer = null;
                        this.timerCount = 0;
                        this.showPayResult = false;
                    }
                });

                if (this.timerCount > 90) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                    this.showPayResult = false;
                } else {
                    this.timerCount++;
                }
            }, 10000);
        },
        queryPay_CCBC() {
            this.showSpinQuery = true;
            QueryCCBCPay({
                orderNo: this.orderNo,
                orderAmount: this.orderAmount
            }).then(res => {
                this.showSpinQuery = false;
                if (res.code === 0) {
                    // console.log(res);
                    if (res.data.code === 0) {
                        this.payStatus = '已支付';
                        this.$Modal.info({title: '提示', content: '支付成功！'});
                        this.showQueryButton = false;
                        this.closePayWindow();
                    } else if (res.data.code === 4) {
                        this.$Modal.info({title: '提示', content: '未完成支付！'});
                    } else {
                        //this.payStatus = '已支付';
                        this.$Modal.info({title: '提示', content: res.message});
                        this.showQueryButton = false;
                    }
                }
            });
        },
        queryPay_nonghang() {
            this.showSpinQuery = true;
            QueryABCPay({
                orderNo: this.orderNo
            }).then(res => {
                this.showSpinQuery = false;
                if (res.code === 0) {
                    // console.log(res);
                    if (res.data.result.status === '03' || res.data.result.status === '04') {
                        this.payStatus = '已支付';
                        this.$Modal.info({title: '提示', content: '支付成功！'});
                        this.showQueryButton = false;
                        this.closePayWindow();
                    } else {
                        this.$Modal.info({title: '提示', content: '未完成支付！'});
                    }
                }
            });
        },
        queryPay_self() {
            if (this.payType === 'Weixin' || this.payCode === 'WeiXin') {
                this.showSpinQuery = true;
                queryWeiXinPay({
                    tradeNo: this.orderNo
                }).then(res => {
                    this.showSpinQuery = false;
                    if (res.code === 0) {
                        console.log(res);
                        if (res.data.dictResult.trade_state === 'SUCCESS') {
                            this.payStatus = '已支付';
                            this.$Modal.info({title: '提示', content: '支付成功！'});
                            this.showQueryButton = false;
                            this.closePayWindow();
                        } else {
                            this.$Modal.info({
                                title: '提示',
                                content: '未完成支付:' + res.data.dictResult.trade_state_desc
                            });
                        }
                    }
                });
            } else if (this.payType === 'Alipay' || this.payCode === 'Alipay') {
                this.showSpinQuery = true;
                queryAliPay({
                    tradeNo: this.orderNo
                }).then(res => {
                    this.showSpinQuery = false;
                    if (res.code === 0) {
                        console.log(res);
                        if (res.data.payStatus === 'TRADE_SUCCESS' || res.data.payStatus
                            === 'TRADE_FINISHED') {
                            this.payStatus = '已支付';
                            this.$Modal.info({title: '提示', content: '支付成功！'});
                            this.showQueryButton = false;
                            this.closePayWindow();
                        } else {
                            this.$Modal.info({title: '提示', content: '未完成支付:' + res.data.response.sub_msg});
                        }
                    }
                });
            }
        },
        queryPay_wx() {
            this.showQueryButton = false;
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                console.log(this.timerCount);
                if (!this.showPayResult) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                }
                queryWeiXinPay({
                    tradeNo: this.orderNo
                }).then(res => {
                    this.showSpinQuery = false;
                    if (res.code === 0) {
                        console.log(res);
                        if (res.data.dictResult.trade_state === 'SUCCESS') {
                            clearInterval(this.timer);   //清除定时器
                            this.timer = null;
                            this.timerCount = 0;
                            this.payStatus = '已支付';
                            this.showPayResult = false;
                            this.$Modal.info({title: '提示', content: '支付成功！'});
                            this.showQueryButton = false;
                            this.show = false;
                            this.$emit('refresh-data');
                            //this.closePayWindow();
                        }
                    }
                });

                if (this.timerCount > 90) {
                    clearInterval(this.timer);   //清除定时器
                    this.timer = null;
                    this.timerCount = 0;
                    this.showPayResult = false;
                } else {
                    this.timerCount++;
                }
            }, 6000);

        }
    }
};
</script>

<style>
.pay_logo {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 在线充值账户名 */
.pay-username {
    position: relative;
    right: 165px;
    font-size: 22px;
    color: #333;
}

/* 账户金额信息 */
.custome-info-wrap {
    padding: 15px;
    background-color: #ecf5ff;
    border: 1px solid #2979ff;
    border-radius: 10rpx;
    width: 460px;
    border-radius: 5px;
    font-size: 16px;
}

.pay_type {
    width: 450px;
    /* height: 160px; */
    /* padding-left: 20px;
    padding-right: 20px; */
    /* 	display: flex;
    justify-content: space-between;
    align-items: center; */
    /* border-bottom: 1px solid lightgrey; */
}

.pay_type_radio {
    margin-top: 20px !important;

}

.pay_type_radio img {
    height: 30px;
    margin-left: 10px;
}

.pay_type_group b-form-radio {
    display: inline-block !important;
}


/* .pay_type b-form-group{display: inline-block;} */
.pay_type_group .pay-type-group {
    display: inline-block;
}

.pay_type_radio .custom-control .custom-radio {
    display: inline-block !important;
}

.custome_value {
    width: 490px;
    display: flex;
    /* justify-content: center;	 */
    padding-left: 18px;
    align-items: center;
    margin-top: 20px;
    /* border-bottom: 1px solid lightgrey; */
    margin-bottom: 30px;
    /* padding-bottom: 10px; */
}

.custome_value span {
    font-size: 20px;
    color: #333;
}

.default_value_button {
    width: 450px;
    display: flex;
    justify-content: space-around;
}

.default_value_button button {
    width: 80px;
    color: #969696;
    background-color: transparent;
    border: 1px solid #969696;
}

.pay_div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    width: 460px;
    /* border: solid 1px lightgrey; */
}

.pay_result {
    padding: 10px;
    border: solid 1px lightgrey;
}

/*会员充值抬头修改样式*/
.modal-header {
    background-color: #1da25a;
    color: #fff;
}

.close {
    color: #FFF
}

.close:hover {
    color: #FFF
}

/*会员充值金额文字修改样式*/
.custome_value span {
    color: #333;
}

/*会员充值支付方式修改样式*/
.custom-control-label img {
    margin-right: 10px;
}

</style>
